const footing = (props) => {
    return (
        <footer>
            Created by Akeem Foster @  <a href="https://junocollege.com/">Juno College</a>
        </footer>
    )
}

export default footing